import React from "react";
import { Spinner } from "react-bootstrap";

interface LoadingSpinnerProps {
  themeColor?: string;
  label?: string;
}
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  themeColor = "#d2363a",
  label
}) => {
  return (
    <div className="d-flex justify-content-center align-items-center py-5">
      <Spinner
        animation="border"
        role="status"
        style={{ borderColor: themeColor, borderRightColor: "transparent" }}
      >
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      {label && <span className="ms-2" style={{ color: themeColor }}>{label}</span>}
    </div>
  );
};

export default LoadingSpinner;
